import { Editor, Text } from 'slate';

function getTextAtRange(editor, at) {
  return Array.from(Editor.nodes(editor, {
    at,
    match: Text.isText,
    voids: true
  }));
}

export { getTextAtRange };
